export enum paletteTypes {
    FETCH_TEMPLATES_REQUEST = 'FETCH_TEMPLATES_REQUEST',
    FETCH_PALETTE_REQUEST = 'FETCH_PALETTE_REQUEST',
    UPDATE_PALETTE_REQUEST = 'UPDATE_PALETTE_REQUEST',
    FETCH_COLORS_TEMPLATES_REQUEST = 'FETCH_COLORS_TEMPLATES_REQUEST',
    FETCH_IMAGES_TEMPLATES_REQUEST = 'FETCH_IMAGES_TEMPLATES_REQUEST',
    SET_PALETTE = 'SET_PALETTE',
    SET_TEMPLATES = 'SET_TEMPLATES',
    SET_COLORS_TEMPLATES = 'SET_COLORS_TEMPLATES',
    SET_IMAGES_TEMPLATES = 'SET_IMAGES_TEMPLATES',
    SET_ACTIVE_PALETTE = 'SET_ACTIVE_PALETTE',
    UPDATE_ACTIVE_PALETTE = 'UPDATE_ACTIVE_PALETTE',
}
